export const PUBLIC_FORM_RECAPTCHA_SITE_KEY_PROD = '6Lf5ldQqAAAAAInwi53M6IH4uzy5kaz2PdCXCqvE';
export const PUBLIC_FORM_RECAPTCHA_SITE_KEY_STAGING = '6LcihdQqAAAAAK7LAvWhysMV6yXTUmyJ819CtflJ';
export const PUBLIC_FORM_ANALYTIC_SOURCE = 'publicFormRecaptchaLoad';
export const PUBLIC_FORM_RECAPTCHA_ACTION_NAME = 'public_form_submission';
export const PUBLIC_FORM_RECAPTCHA_CHECKBOX_SITE_KEY_PROD =
	'6LeD1gQrAAAAAKl6iGAFzVkxXc28FOg8WVVp6CtO';
export const PUBLIC_FORM_RECAPTCHA_CHECKBOX_SITE_KEY_STAGING =
	'6Lek1QQrAAAAAGYUb426jBSJbsQLQT1eaXhiEFq7';
